import http from "infra/http";
import { useMutation } from "react-query";

function useAnalisarProcuracao() {
  return useMutation(
    `analisar/v1/votacao`,
    async ({
      idVotacao,
      idProcuracao,
    }: {
      idVotacao: string;
      idProcuracao: string;
    }) => {
      const result = await http.post(
        `/v1/votacao/${idVotacao}/procuracao/${idProcuracao}/analisar`,
      );

      return result;
    },
    { retry: false }
  );
}

export default useAnalisarProcuracao;
